// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-doc-modal-main-container {
  position: relative;
  padding: 0.5rem 0.5rem;
}
.add-doc-modal-main-container .add-doc-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
}
.add-doc-modal-main-container .add-doc-modal .add-doc-modal-form-title {
  text-align: center;
  margin: 0;
  flex: 1 1;
}
.add-doc-modal-main-container .add-doc-modal .add-doc-modal-form-close-button {
  position: absolute;
  right: 20px;
  font-size: 24px;
  background: transparent;
  border: none;
  color: #333;
  cursor: pointer;
  z-index: 2;
  width: 30px;
  height: 30px;
  border-radius: 0.25rem;
}
.add-doc-modal-main-container .add-doc-modal .add-doc-modal-form-close-button:hover {
  color: #333;
  background: #f5f5f5;
}
.add-doc-modal-main-container .doc-form {
  padding: 1rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.add-doc-modal-main-container .doc-form label {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  color: #333;
  gap: 0.5rem;
}
.add-doc-modal-main-container .doc-form label input,
.add-doc-modal-main-container .doc-form label textarea {
  padding: 0.75rem 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}
.add-doc-modal-main-container .doc-form label input:focus,
.add-doc-modal-main-container .doc-form label textarea:focus {
  border-color: var(--primary-color);
  outline: none;
}
.add-doc-modal-main-container .doc-form label input:disabled,
.add-doc-modal-main-container .doc-form label textarea:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}
.add-doc-modal-main-container .doc-form label textarea {
  min-height: 100px;
  resize: vertical;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button {
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
  opacity: 0.6;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:disabled:hover {
  background-color: #a0aec0;
  transform: none;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:first-child {
  background-color: var(--primary-color);
  color: white;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:first-child:hover {
  background-color: #0056b3;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:last-child {
  background-color: #f1f1f1;
  color: #333;
}
.add-doc-modal-main-container .doc-form .add-doc-form-actions button:last-child:hover {
  background-color: #ddd;
}`, "",{"version":3,"sources":["webpack://./src/pages/DocRequestForm/DocRequestForm.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EAGA,sBAAA;AADF;AAGE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;EACA,kBAAA;AADJ;AAGI;EACE,kBAAA;EACA,SAAA;EACA,SAAA;AADN;AAII;EACE,kBAAA;EAEA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAHN;AAIM;EACE,WAAA;EACA,mBAAA;AAFR;AAOE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AALJ;AAOI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AALN;AAOM;;EAEE,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AALR;AAOQ;;EACE,kCAAA;EACA,aAAA;AAJV;AAOQ;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAJV;AAQM;EACE,iBAAA;EACA,gBAAA;AANR;AAUI;EACE,aAAA;EACA,yBAAA;EACA,SAAA;AARN;AAUM;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;AARR;AAUQ;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AARV;AAUU;EACE,yBAAA;EACA,eAAA;AARZ;AAYQ;EACE,sCAAA;EACA,YAAA;AAVV;AAYU;EACE,yBAAA;AAVZ;AAcQ;EACE,yBAAA;EACA,WAAA;AAZV;AAcU;EACE,sBAAA;AAZZ","sourcesContent":[".add-doc-modal-main-container {\n  position: relative;\n  //padding: 1.5rem;\n  //padding:1.5rem 1.5rem;\n  padding: 0.5rem 0.5rem;\n\n  .add-doc-modal {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid #e0e0e0;\n    position: relative;\n\n    .add-doc-modal-form-title {\n      text-align: center;\n      margin: 0;\n      flex: 1;\n    }\n\n    .add-doc-modal-form-close-button {\n      position: absolute;\n      //top: 25px;\n      right: 20px;\n      font-size: 24px;\n      background: transparent;\n      border: none;\n      color: #333;\n      cursor: pointer;\n      z-index: 2;\n      width: 30px;\n      height: 30px;\n      border-radius: 0.25rem;\n      &:hover {\n        color: #333;\n        background: #f5f5f5;\n      }\n    }\n  }\n\n  .doc-form {\n    padding: 1rem;\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n\n    label {\n      display: flex;\n      flex-direction: column;\n      font-weight: 600;\n      color: #333;\n      gap: 0.5rem;\n\n      input,\n      textarea {\n        padding: 0.75rem 1rem;\n        border: 1px solid #ccc;\n        border-radius: 6px;\n        font-size: 1rem;\n        transition: border-color 0.3s ease;\n\n        &:focus {\n          border-color: var(--primary-color);\n          outline: none;\n        }\n\n        &:disabled {\n          background-color: #e9ecef;\n          color: #6c757d;\n          cursor: not-allowed;\n        }\n      }\n\n      textarea {\n        min-height: 100px;\n        resize: vertical;\n      }\n    }\n\n    .add-doc-form-actions {\n      display: flex;\n      justify-content: flex-end;\n      gap: 1rem;\n\n      button {\n        padding: 0.6rem 1.2rem;\n        border: none;\n        border-radius: 6px;\n        font-size: 1rem;\n        cursor: pointer;\n        transition: background 0.3s ease;\n\n        &:disabled {\n          background-color: #a0aec0;\n          cursor: not-allowed;\n          opacity: 0.6;\n\n          &:hover {\n            background-color: #a0aec0;\n            transform: none;\n          }\n        }\n\n        &:first-child {\n          background-color: var(--primary-color);\n          color: white;\n\n          &:hover {\n            background-color: #0056b3;\n          }\n        }\n\n        &:last-child {\n          background-color: #f1f1f1;\n          color: #333;\n\n          &:hover {\n            background-color: #ddd;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
